import Content from './terms-of-use.md';
import { Self } from '@/vue-core';
import { defineComponent, reactive } from '@vue/composition-api';
export default defineComponent({
    setup(props, context) {
        let self = new Self(context);
        // =================
        //
        // state
        //
        let $ = reactive({
            content: Content
        });
        // =================
        //
        // done
        //
        return {
            $
        };
    }
});
